import React from "react"
import moment from "moment-jalaali"
import { useTranslation } from "react-i18next"

import { ShiftCashierSeparator } from "components"
import { haveAuth, thousandSeparator } from "utils"
import ShiftCashierHistoryPrintButton from "./ShiftCashierHistoryPrintButton"
import classes from "./ShiftCashierHistoryDetails.module.scss"

const ShiftCashierHistoryDetails = props => {
  const { selectedShift } = props

  const [t] = useTranslation()

  const {
    startingCash,
    startAt,
    endAt,
    paidIns,
    paidOuts,
    taxesAndCharges,
    refund,
    discounts,
    actualCashAmount,
    payments = { "نقدی": 0 }
  } = selectedShift

  const cashTypes = Object.keys(payments)

  const totalTendered =
    cashTypes.reduce((t, cashType) => t += payments[cashType], 0)

  const totalPaidIns =
    paidIns.reduce((t, paidIn) => t += paidIn.amount, 0)

  const totalPaidOuts =
    paidOuts.reduce((t, paidOut) => t += paidOut.amount, 0)

  const expectedCashAmount =
    Math.round(
      (payments["نقدی"] || 0) +
      startingCash +
      totalPaidIns -
      totalPaidOuts -
      refund
    )

  const grossSales =
    totalTendered + discounts

  const netSales =
    totalTendered - taxesAndCharges - refund

  return (
    <div className={classes["container"]}>
      <div className={classes["section"]}>
        <div className={classes["row"]}>
          <div>
            {t("شروع_شیفت")}
          </div>
          <div className={classes["time"]}>
            {moment(startAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>

        {
          !!endAt &&
          <div className={classes["row"]}>
            <div>
              {t("اتمام_شیفت")}
            </div>
            <div className={classes["time"]}>
              {moment(endAt).format("jYYYY/jMM/jDD - HH:mm")}
            </div>
          </div>
        }
      </div>

      <div className={classes["section"]}>
        {cashTypes.map(cashType =>
          payments[cashType] !== 0 &&
          <div key={cashType} className={classes["row"]}>
            <div>
              {cashType}
            </div>
            <div>
              {thousandSeparator(payments[cashType])}
            </div>
          </div>
        )}

        <div className={classes["row"]}>
          <div>
            {t("تخفیف_ها")}
          </div>
          <div>
            {thousandSeparator(discounts)}
          </div>
        </div>

        <ShiftCashierSeparator />

        <div className={classes["row"]}>
          <b>
            {t("فروش_ناخالص")}
          </b>
          <b>
            {thousandSeparator(grossSales)}
          </b>
        </div>

        <div className={classes["row"]}>
          <b>
            {t("دریافتی_از_مشتری")}
          </b>
          <b>
            {thousandSeparator(totalTendered)}
          </b>
        </div>
      </div>

      <div className={classes["section"]}>
        <div className={classes["row"]}>
          <div>
            {t("پول_مرجوعی")}
          </div>
          <div>
            {thousandSeparator(refund)}
          </div>
        </div>

        <div className={classes["row"]}>
          <div>
            {t("مالیات_و_خدمات")}
          </div>
          <div>
            {thousandSeparator(taxesAndCharges)}
          </div>
        </div>

        <ShiftCashierSeparator />

        <div className={classes["row"]}>
          <b>
            {t("فروش_خالص")}
          </b>
          <b>
            {thousandSeparator(netSales)}
          </b>
        </div>
      </div>

      <div className={classes["section"]}>
        <div className={classes["row"]}>
          <div>
            {t("پول_اولیه_صندوق")}
          </div>
          <div>
            {thousandSeparator(startingCash)}
          </div>
        </div>

        <div className={classes["row"]}>
          <div>
            {t("واریز_به_صندوق")}
          </div>
          <div>
            {thousandSeparator(totalPaidIns)}
          </div>
        </div>

        <div className={classes["row"]}>
          <div>
            {t("برداشت_از_صندوق")}
          </div>
          <div>
            {thousandSeparator(totalPaidOuts)}
          </div>
        </div>

        <ShiftCashierSeparator />

        <div className={classes["row"]}>
          <b>
            {t("موجودی_صندوق")}
          </b>
          <b>
            {thousandSeparator(expectedCashAmount)}
          </b>
        </div>

        <div className={classes["row"]}>
          <b>
            {t("موجودی_صندوق_واقعی")}
          </b>
          <b>
            {thousandSeparator(actualCashAmount)}
          </b>
        </div>
      </div>

      {
        haveAuth(["printerAccess"]) &&
        <ShiftCashierHistoryPrintButton
          selectedShift={selectedShift}
        />
      }
    </div>
  )
}

export default ShiftCashierHistoryDetails